import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import EstimateTab from './EstimateTab';
import NewEstimateButton from './NewEstimateButtonConnector';
import PropertyAddress from './PropertyAddressConnector';
import VendorInformation from './VendorInformationConnector';
import JobNotes from './JobNotesConnector';
import SaveProductDesignMessage from './SaveProductDesignMessage';
import { sites } from '../helpers/globalVariables';
import config from '../helpers/config';
import PhoneNumber from './PhoneNumber';
import { TabPhoneContainer } from './styles';

const savingInPageTitle = window.globalConfig.siteId === sites.theHomeDepot ? 'My Window Treatments' : 'My Estimates';
const savingInUrl = window.globalConfig.siteId === sites.theHomeDepot ? `${config.mandiBaseUrl}mywindowtreatments` : '/myaccount/estimates';
const showCECPhoneNumberTHD = window.globalConfig.siteId === sites.theHomeDepot;

const EstimateBuilderHeader = props => (
  <div className="estimateBuilderHeader">
    {props.saveProductDesignAlert && (
      <SaveProductDesignMessage title="Product saved to this design" cta={props.saveProductDesignDismiss}>
        <span>Find a direct link in your email inbox or in My Account&apos;s<a href={savingInUrl} className="save-product-link">{savingInPageTitle}</a>.</span>
      </SaveProductDesignMessage>
    )}
    <div className="header">
      <h1 className="header-title">My Designs</h1>
      {props.isMandi && <PropertyAddress />}
    </div>
    {(props.isMandi && props.isInternalUser) ?
      <Fragment>
        <VendorInformation />
        <JobNotes />
      </Fragment> :
      ''
    }
    <TabPhoneContainer>
      <div id="estimateTabs" className="estimateTabs">
        {!props.isAutoReleaseDesign && <NewEstimateButton />}
        <div className="tabs">
          {props.isAutoReleaseDesign
          ? props.autoReleaseDesigns.map(id =>
              (<EstimateTab
                designId={id}
                key={id}
                allowClosing={false}
              />))
          : props.designIds.map(id =>
            (<EstimateTab
              designId={id}
              key={id}
            />))}
        </div>
      </div>
      { showCECPhoneNumberTHD &&
        <PhoneNumber phoneNumber={props.phoneNumber} />
      }
    </TabPhoneContainer>
  </div>
);

EstimateBuilderHeader.propTypes = {
  designIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  autoReleaseDesigns: PropTypes.arrayOf(PropTypes.string),
  isMandi: PropTypes.bool.isRequired,
  isAutoReleaseDesign: PropTypes.bool.isRequired,
  isInternalUser: PropTypes.bool.isRequired,
  saveProductDesignAlert: PropTypes.bool,
  saveProductDesignDismiss: PropTypes.func.isRequired,
  phoneNumber: PropTypes.string,
};

EstimateBuilderHeader.defaultProps = {
  saveProductDesignAlert: false,
  phoneNumber: '1-800-340-2850',
  autoReleaseDesigns: [],
};

export default EstimateBuilderHeader;
